import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function useFilterParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const setParam = useCallback((key, value) => {
    const params = new URLSearchParams(searchParams)
    if (value === '' || value === 'All' || value === 'name-asc') {
      params.delete(key)
    } else {
      params.set(key, value)
    }
    params.delete('page')
    setSearchParams(params, { replace: true })
  }, [searchParams, setSearchParams])

  const setCurrentPage = useCallback((page) => {
    const params = new URLSearchParams(searchParams)
    if (page <= 1) {
      params.delete('page')
    } else {
      params.set('page', page.toString())
    }
    setSearchParams(params, { replace: true })
  }, [searchParams, setSearchParams])

  const resetFilters = useCallback((filterKeys) => {
    const params = new URLSearchParams(searchParams)
    for (const key of filterKeys) {
      params.delete(key)
    }
    params.delete('q')
    params.delete('sort')
    params.delete('page')
    setSearchParams(params, { replace: true })
  }, [searchParams, setSearchParams])

  const read = useCallback((key, fallback = '') => searchParams.get(key) || fallback, [searchParams])

  const setMultipleParams = useCallback((params) => {
    const next = new URLSearchParams(searchParams)
    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === '' || value === 'All' || value === 'name-asc') {
        next.delete(key)
      } else {
        next.set(key, value)
      }
    })
    setSearchParams(next, { replace: true })
  }, [searchParams, setSearchParams])

  return { searchParams, setParam, setCurrentPage, resetFilters, read, setMultipleParams }
}
